import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface IServer extends IEntity {
  attributes: {
    // Note, server id is not uuid, it's internal id from redis,
    // it seems
    id: EntityStringId;
    socketUrl: string;
  }
}

export type Server = Entity<IServer>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Server: IEntityType<IServer> = vmClient.defineClass({
  typeName: 'Rtc.Server',
  version: 1,

  attributes: {
    id: { type: 'string', notNull: true },
    socketUrl: { type: 'string', notNull: true },
  },
});
